import client from '../../client'
import { ListPlansResponse, ListResponse } from './types'

export * from './types'

export const listPlans = async () => {
  const { data }: ListPlansResponse = await client.get(
    `/user/pointSubscriptions/plans`
  )
  return data
}

export const list = async () => {
  const { data }: ListResponse = await client.get(`/user/pointSubscriptions`)
  return data
}

export const subscribe = async (planId: string) => {
  return await client.post(`/user/pointSubscriptions/subscribe`, {
    pointSubscriptionPlanId: planId,
  })
}

export const resume = async () => {
  return await client.put(`/user/pointSubscriptions/resume`)
}

export const cancel = async () => {
  return await client.put(`/user/pointSubscriptions/cancel`)
}

export const getExpiringPointsOnCancel = async () => {
  const { data }: { data: number } = await client.get(
    `/user/pointSubscriptions/pointToLoseByCancelPointSubscription`
  )

  return data
}

export const submitCancelSurvey = async (survey: {
  reasons: string[]
  intentToContinue: string
  otherReason?: string | null
}) => {
  return await client.post(`/user/pointSubscriptions/surveyOnCancel`, survey)
}
